import { ref } from "vue";

// 全局复制提示状态
const showToast = ref(false);
const copiedUrl = ref("");

export function useCopyToast() {
  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      copiedUrl.value = text;
      showToast.value = true;

      // 2.5秒后自动隐藏
      setTimeout(() => {
        showToast.value = false;
      }, 2500);

      return true;
    } catch (err) {
      console.error("Failed to copy:", err);
      // 降级方案：使用传统方法
      try {
        const textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.position = "fixed";
        textArea.style.left = "-999999px";
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);

        copiedUrl.value = text;
        showToast.value = true;

        setTimeout(() => {
          showToast.value = false;
        }, 2500);

        return true;
      } catch (fallbackErr) {
        console.error("Fallback copy failed:", fallbackErr);
        return false;
      }
    }
  };

  return {
    showToast,
    copiedUrl,
    copyToClipboard,
  };
}
